
export class PlanGoodsMaintainModel {
  /**
   * Ｐコード
   */
  public pCode: string = <string>'';

  /**
   * 受注コード
   */
  public orderCode: string = <string>'';

  /**
   * 媒体区分
   */
  public mediumType: string = <string>'';
}
